import Reflux from "reflux";

import Chip from "@javascript/reactComponents/lds/chips/Chip";
import FacetSearchStore from "@javascript/stores/facetSearchStore";
import { FacetSearchStoreActions } from "@javascript/stores/actions/facetSearch/storeActions";

const FacetSearchCriteriaClinicalStatus = createReactClass({
  mixins: [
    Reflux.connectFilter(
      FacetSearchStore,
      ({ clinicalTrialStatuses }) => clinicalTrialStatuses
    ),
  ],

  getInitialState() {
    return { ...FacetSearchStore.data.clinicalTrialStatuses };
  },

  render() {
    const { selected = [] } = this.state;

    if (!selected.length) return null;

    let originalStatus = (Zymewire.original_feed_query || {}).clin_status || [];

    if (originalStatus.length > 0) {
      $("#trial_status_panel").hide();
    }

    const formatSelectedStatuses = (selected, originalStatuses) =>
      _.unique(selected).map((status, index) => ({
        last: index === selected.length - 1,
        locked: originalStatuses.includes(status),
        value: status,
      }));

    return (
      <>
        {formatSelectedStatuses(selected, originalStatus).map(
          ({ last, locked, value }) => (
            <ClinicalStatusAppliedFilterEntry
              key={value}
              last={last}
              locked={locked}
              value={value}
            />
          )
        )}
      </>
    );
  },
});

const ClinicalStatusAppliedFilterEntry = ({ last, locked, value }) => {
  const handleClick = () => {
    if (locked) return;

    const clinicalTrialStatusesSelected = [
      ...FacetSearchStore.data.clinicalTrialStatuses.selected,
    ];
    const selectedIndex = clinicalTrialStatusesSelected.indexOf(value);

    if (selectedIndex > -1) {
      clinicalTrialStatusesSelected.splice(selectedIndex, 1);

      FacetSearchStoreActions.clinicalTrialStatusesUpdate(
        { selected: clinicalTrialStatusesSelected },
        { doSearch: true, triggerStateUpdate: false }
      );
    }

    return false;
  };

  const trialStatusDisplayName =
    FacetSearchStore.data.clinicalTrialStatuses.display[value];

  const label = (
    <>
      {Zymewire.facet_search_filters.trial_status}: {trialStatusDisplayName}
      {!last && <b> OR</b>}
    </>
  );

  return (
    <Chip
      className="search_filter_applied_chip"
      label={label}
      leadingIcon="trial_status"
      size="small"
      {...(!locked && {
        trailingIcon: "cancel",
        trailingIconClassName: "search_filter_applied_trailing_icon",
        trailingIconOnClick: handleClick,
      })}
      variant="secondary"
    />
  );
};

window.FacetSearchCriteriaClinicalStatus = FacetSearchCriteriaClinicalStatus;
export default FacetSearchCriteriaClinicalStatus;
